export const SERVICES = [
  {
    slug: "conseil-gestion",
    title: "Conseil en gestion d'Entreprise",
    short: "Diagnostic, stratégie, optimisation des process et accompagnement des dirigeants.",
    items: [
      "Diagnostic global d'Entreprise",
      "Conseil en stratégie et développement",
      "Optimisation des process",
      "Conseil en gestion des coûts",
      "Accompagnement des dirigeants",
      "Analyse de performance et tableaux de bord",
    ],
  },
  {
    slug: "creation-entreprise",
    title: "Création et accompagnement d'Entreprise",
    short: "De l'idée à l'immatriculation : statuts, formalités, micro-entreprise.",
    items: [
      "Accompagnement au choix du statut juridique",
      "Rédaction et montage des dossiers de création",
      "Aide à la domiciliation et formalités administratives",
      "Accompagnement micro-entreprise",
      "Conseil en choix de forme juridique",
      "Accompagnement post-création",
    ],
  },
  {
    slug: "previsionnel-financier",
    title: "Prévisionnel et analyse financière",
    short: "Business plan, prévisionnel sur 3 ans, rentabilité et négociation bancaire.",
    items: [
      "Élaboration de business plan complet",
      "Prévisionnel financier sur 3 ans",
      "Analyse de bilans et comptes de résultat",
      "Tableaux de bord de gestion",
      "Analyse de rentabilité",
      "Aide à la négociation bancaire",
    ],
  },
  {
    slug: "montage-projets",
    title: "Montage de projets & Financement",
    short: "Levée de fonds, aides, subventions, appels d'offres, projets BTP et immobiliers.",
    items: [
      "Montage de dossiers de financement",
      "Recherche d'aides et subventions",
      "Accompagnement levée de fonds",
      "Montage de projets immobiliers",
      "Accompagnement appels d'offres",
      "Montage de projets BTP",
    ],
  },
  {
    slug: "ressources-humaines",
    title: "Ressources Humaines & Social",
    short: "Recrutement, fiches de poste, règlement intérieur, gestion des litiges.",
    items: [
      "Conseil en recrutement",
      "Rédaction de fiches de poste",
      "Accompagnement à l'embauche",
      "Conseil en gestion des ressources humaines",
      "Mise en place de règlement intérieur",
      "Accompagnement plan de formation",
      "Affichage obligatoire",
      "Accompagnement de litiges",
      "Documents obligatoires",
    ],
  },
  {
    slug: "formation-coaching",
    title: "Formation & Coaching dirigeants",
    short: "Formations gestion, fiscale, ateliers, coaching individuel et mentorat.",
    items: [
      "Formation en gestion d'entreprise",
      "Formation administrative et fiscale",
      "Formation à la création d'entreprise",
      "Ateliers pratiques entrepreneurs",
      "Coaching individuel dirigeants",
      "Mentorat porteurs de projet",
      "Conférences et séminaires",
    ],
  },
  {
    slug: "btp-secteurs",
    title: "Spécialité BTP & Secteurs spécifiques",
    short: "Conseil pour le BTP, l'aide à domicile, le nettoyage industriel et la conciergerie.",
    items: [
      "Conseil en développement Entreprises BTP et autres",
      "Montage de dossiers chantiers",
      "Accompagnement sous-traitance",
      "Conseil secteur Aide à Domicile",
      "Conseil secteur nettoyage industriel",
      "Conseil secteur conciergerie",
    ],
  },
  {
    slug: "particuliers",
    title: "Services aux Particuliers",
    short: "Création de micro-entreprise, aide administrative, reconversion, gestion patrimoniale.",
    items: [
      "Accompagnement création de micro-entreprise",
      "Aide administrative (dossiers, courriers, démarches)",
      "Montage de dossiers de financement personnel",
      "Coaching reconversion professionnelle",
      "Conseil en gestion budgétaire et patrimoniale",
      "Accompagnement projet de création d'activité",
    ],
  },
];

export const WHY_US = [
  "Expérience terrain de dirigeants multi-sociétés",
  "Approche globale et personnalisée",
  "Disponibilité et réactivité",
  "Tarifs adaptés à chaque situation",
  "Intervention auprès des Professionnels et des Particuliers",
  "Ancrage dans le Nord de France, intervention partout en France",
];

export const ARTICLES = [
  {
    slug: "creer-micro-entreprise-2026",
    title: "Créer sa micro-entreprise en 2026 : les étapes clés",
    excerpt: "Statut juridique, immatriculation, fiscalité, cotisations sociales : tout ce qu'il faut savoir avant de se lancer.",
    date: "12 Janvier 2026",
    category: "Création d'entreprise",
    readTime: "6 min",
    content: `La micro-entreprise reste en 2026 l'un des statuts les plus accessibles pour lancer une activité indépendante. Pourtant, derrière sa simplicité apparente se cachent plusieurs choix structurants qui détermineront la viabilité de votre projet.

**1. Bien définir son activité**
Avant toute formalité, clarifiez la nature de votre activité : prestation de services, vente de marchandises, profession libérale. Le régime fiscal et social en dépend directement.

**2. L'immatriculation simplifiée**
La déclaration se fait en ligne via le guichet unique de l'INPI. Comptez environ 15 jours pour recevoir votre SIRET. Pensez à ouvrir un compte bancaire dédié dès le premier mois d'activité.

**3. Le plafond de chiffre d'affaires**
En 2026, les seuils restent à 77 700 € pour les services et 188 700 € pour la vente. Au-delà, vous basculez automatiquement vers le régime réel.

**4. Anticiper la TVA**
La franchise en base de TVA s'applique jusqu'à 36 800 € (services) ou 91 900 € (vente). Au-dessus, vous devez facturer et reverser la TVA.

Chez AXIOM, nos conseillers vous accompagnent à chaque étape pour éviter les pièges classiques et structurer votre activité dès le départ.`,
  },
  {
    slug: "financement-btp-aides",
    title: "Financement BTP : les aides souvent oubliées par les entreprises",
    excerpt: "Subventions régionales, prêts d'honneur, garanties BPI : un panorama des dispositifs accessibles aux artisans du bâtiment.",
    date: "5 Janvier 2026",
    category: "BTP & Financement",
    readTime: "8 min",
    content: `Le secteur du BTP traverse une période exigeante : hausse des matériaux, normes RE2020, tensions sur les recrutements. Bonne nouvelle : de nombreux dispositifs de financement existent, mais restent largement sous-utilisés.

**Les prêts d'honneur**
Réseau Entreprendre, Initiative France, France Active proposent des prêts à taux zéro de 5 000 à 90 000 €, sans garantie personnelle. Idéaux pour renforcer les fonds propres avant un dossier bancaire.

**Les aides régionales Hauts-de-France**
La Région finance jusqu'à 50 % des investissements liés à la transition écologique du bâtiment : véhicules propres, équipements basse consommation, formation aux nouveaux matériaux.

**Les garanties BPI**
La BPI peut garantir jusqu'à 70 % d'un emprunt bancaire, ce qui débloque souvent les dossiers refusés en première lecture.

**L'affacturage et le financement de chantier**
Pour les TPE BTP, l'affacturage permet de financer les situations de travaux dès leur émission, sans attendre 60 ou 90 jours.

Nos conseillers AXIOM, spécialisés BTP, montent régulièrement des plans de financement combinant 3 à 5 dispositifs pour maximiser le levier.`,
  },
  {
    slug: "rh-tpe-erreurs-eviter",
    title: "Embaucher son premier salarié en TPE : les 5 erreurs à éviter",
    excerpt: "DPAE, contrat, période d'essai, mutuelle, affichage : ce que vous devez sécuriser avant la première paie.",
    date: "28 Décembre 2025",
    category: "Ressources Humaines",
    readTime: "5 min",
    content: `Embaucher son premier collaborateur est un jalon important. C'est aussi le moment où une TPE bascule dans un cadre juridique exigeant, avec des obligations qui ne pardonnent pas.

**Erreur 1 : oublier la DPAE**
La Déclaration Préalable à l'Embauche doit être effectuée au maximum 8 jours avant l'arrivée du salarié. Son oubli expose à des sanctions pénales et au redressement URSSAF.

**Erreur 2 : un contrat de travail flou**
Mention des heures, du salaire brut, de la convention collective applicable, de la période d'essai : chaque clause doit être pesée. Un CDI mal rédigé peut coûter cher en cas de rupture.

**Erreur 3 : négliger la mutuelle obligatoire**
Depuis 2016, l'employeur doit proposer une mutuelle santé collective et en financer au moins 50 %.

**Erreur 4 : ignorer l'affichage obligatoire**
Coordonnées de l'inspection du travail, médecine du travail, convention collective, horaires : autant d'éléments qui doivent être visibles dans les locaux.

**Erreur 5 : sous-estimer le coût total**
Un salaire brut de 2 000 € coûte environ 2 800 € à l'entreprise charges patronales comprises. À intégrer impérativement dans votre prévisionnel.

AXIOM vous accompagne sur l'ensemble du parcours RH, du recrutement à la mise en conformité.`,
  },
  {
    slug: "business-plan-bancaire",
    title: "Business plan : ce que votre banquier regarde vraiment",
    excerpt: "Au-delà des chiffres, quelques règles concrètes pour transformer votre dossier en feu vert bancaire.",
    date: "18 Décembre 2025",
    category: "Financement",
    readTime: "7 min",
    content: `Un business plan n'est pas un document littéraire : c'est un outil de décision. Le banquier qui le lit cherche en quelques minutes à répondre à trois questions simples.

**1. L'équipe est-elle crédible ?**
Le porteur de projet a-t-il l'expérience, les compétences, les apports personnels nécessaires ? Une présentation honnête des forces ET des fragilités inspire davantage confiance qu'un dossier "trop parfait".

**2. Le marché est-il réel ?**
Études de marché, concurrents identifiés, premiers clients potentiels, lettres d'intention : tout ce qui prouve qu'il y a une demande solvable.

**3. Les chiffres tiennent-ils la route ?**
Un prévisionnel cohérent avec le marché, des hypothèses justifiées, une trésorerie qui ne plonge pas dans le rouge dès le mois 3, un plan de financement équilibré.

**Les ratios à surveiller**
- Apport personnel : minimum 20-30 % du besoin total
- Trésorerie de démarrage : 3 à 6 mois de charges fixes
- Capacité d'autofinancement positive dès l'année 2

Chez AXIOM, nous construisons des business plans qui parlent le langage des banquiers et des investisseurs, tout en restant fidèles à votre vision entrepreneuriale.`,
  },
  {
    slug: "appel-offres-tpe-pme",
    title: "Répondre à un appel d'offres quand on est une TPE : guide pratique",
    excerpt: "Les marchés publics sont accessibles aux petites structures. Voici comment ne pas se faire piéger par les procédures.",
    date: "10 Décembre 2025",
    category: "Développement",
    readTime: "6 min",
    content: `Les marchés publics représentent près de 100 milliards d'euros par an en France. Pourtant, seules 35 % des TPE candidatent, persuadées que "ce n'est pas pour elles". Erreur stratégique.

**Identifier les bons marchés**
BOAMP, Marches-Online, plateformes régionales : tout est gratuit et accessible. Filtrez par CPV, géographie, montant pour cibler ce qui correspond à votre savoir-faire.

**Le DUME, votre meilleur ami**
Le Document Unique de Marché Européen simplifie les pièces administratives. Une fois rempli, il se réutilise pour la plupart des appels d'offres.

**Le mémoire technique fait la différence**
À prix équivalent, c'est la qualité du mémoire qui distingue les candidats. Méthodologie, planning, équipe dédiée, références similaires : soyez précis et factuel.

**Les groupements momentanés**
Vous êtes trop petit seul ? Constituez un groupement avec d'autres TPE complémentaires. Vous additionnez chiffres d'affaires et références.

**Anticiper les délais de paiement**
Les marchés publics payent en 30 jours en théorie, plus souvent 60. Prévoyez votre trésorerie en conséquence ou activez la cession Dailly.

Nos conseillers AXIOM accompagnent régulièrement TPE et PME du Nord dans la réponse aux appels d'offres, du sourcing à la signature.`,
  },
];

export const COMPANY = {
  name: "AXIOM",
  tagline: "Conseil & Accompagnement d'Entreprise",
  phone: "07 66 10 89 64",
  email: "contact.axiom.nord@gmail.com",
  address: "991 Route du Berdyck, 59143 Millam — Nord de France",
  rcs: "RCS Dunkerque 502 895 824",
};
